import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface QUIZ_UI_STATE_TYPE {
  createQuizActive: boolean;
  isEditingQuiz: boolean;
}

const INITIAL_STATE: QUIZ_UI_STATE_TYPE = {
  createQuizActive: false,
  isEditingQuiz: false,
};

const quizUiSlice = createSlice({
  name: 'quizUi',
  initialState: INITIAL_STATE,
  reducers: {
    setCreateQuizActive(state: QUIZ_UI_STATE_TYPE, action: PayloadAction<boolean>) {
      state.createQuizActive = action.payload;
    },
    setIsEditingQuiz(state: QUIZ_UI_STATE_TYPE, action: PayloadAction<boolean>) {
      state.isEditingQuiz = action.payload;
    },
    resetQuizUi(state: QUIZ_UI_STATE_TYPE) {
      state.createQuizActive = INITIAL_STATE.createQuizActive;
      state.isEditingQuiz = INITIAL_STATE.isEditingQuiz;
    },
  },
});

export const { setCreateQuizActive, setIsEditingQuiz, resetQuizUi } = quizUiSlice.actions;
export default quizUiSlice.reducer;
